import { EcoSystemSectionType } from "../../../utility/types/generaTypes";
import EcoSystemCard from "../ecoSystemCard/EcoSystemCard";
import "./TechEcoSystemSection.css";
type TechEcoSystemSectionProps = {
  ecoSystemData: EcoSystemSectionType;
  style?: any;
};

const TechEcoSystemSection = ({
  ecoSystemData,
  style,
}: TechEcoSystemSectionProps) => {
  return (
    <section className=" techEcoSystem_section" style={style}>
      <div className="app_section">
        <div className="appSection_header_container">
          <h1 className="section_title">{ecoSystemData.title}</h1>
          <p className="section_description">{ecoSystemData.description}</p>
        </div>
        <div className="techEcoSystemCards_container">
          {ecoSystemData.data.map((service, index) => (
            <EcoSystemCard
              key={"WhyChooseTechCard" + index}
              ecoSystem={service}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechEcoSystemSection;
